<template>
  <div>
    <page-header title="舆情内容" description="查看公开平台采集到的原文，不包含作品运营指标">
      <el-button :loading="starting" @click="start">启动舆情采集</el-button>
    </page-header>
    <el-card v-loading="loading">
      <el-alert v-if="loadError" type="warning" :title="loadError" :closable="false" show-icon />
      <el-table :data="items" empty-text="完成公开舆情采集后，品牌相关原文会显示在这里">
        <el-table-column label="原文" min-width="300"><template slot-scope="scope"><b>{{ scope.row.title || scope.row.source_id }}</b><div>{{ scope.row.content_text || scope.row.summary || '平台暂未返回正文摘要' }}</div></template></el-table-column>
        <el-table-column label="平台" width="100"><template slot-scope="scope"><platform-tag :value="scope.row.platform" /></template></el-table-column>
        <el-table-column prop="author_name" label="作者" width="130" />
        <el-table-column prop="published_at" label="发布时间" width="170" />
        <el-table-column label="原文" width="90"><template slot-scope="scope"><a v-if="scope.row.source_url" :href="scope.row.source_url" target="_blank">查看</a></template></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script>
import { yuqingApi, loadLatestCandidates } from '@/api/yuqing'
import PageHeader from '../components/PageHeader.vue'
import PlatformTag from '../components/PlatformTag.vue'
export default {
  components: { PageHeader, PlatformTag },
  data () { return { loading: true, starting: false, items: [], loadError: '' } },
  mounted () { this.load() },
  methods: {
    async load () { this.loading = true; try { const result = await loadLatestCandidates(); this.items = result.candidates || []; this.loadError = result.error || '' } catch (error) { this.loadError = error.message || '舆情内容暂不可用' } finally { this.loading = false } },
    async start () { this.starting = true; try { await yuqingApi.post('public-opinion/refresh', {}); this.$message.success('舆情采集已启动'); await this.load() } catch (error) { this.$message.error(error.message) } finally { this.starting = false } }
  }
}
</script>
